import DashboardComponentHeader from 'components/dashboard/common/DashboardComponentHeader';
import { IEntryLine } from 'types/Draws';
import TicketStack from './TicketStack';

import styles from './EntriesAndStats.module.css';

const TicketEntries = ({
  subscriptionEntries,
  addonEntries,
  loading,
}: {
  subscriptionEntries: IEntryLine[];
  addonEntries: IEntryLine[];
  loading?: boolean;
}) => {
  return (
    <div className={styles.ticketEntriesContainer}>
      {subscriptionEntries.length > 0 && (
        <TicketStack entries={subscriptionEntries} />
      )}

      {addonEntries.length > 0 && (
        <div>
          <DashboardComponentHeader
            loading={loading}
            title={<div className={styles.titleContainer}>Add-on entries</div>}
            subtitle={'Entered into the next draw'}
          />
          <TicketStack entries={addonEntries} />
        </div>
      )}
    </div>
  );
};

export default TicketEntries;
